var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-container"},[_c('div',{staticClass:"background-image",style:(_vm.backgroundStyles)}),_vm._v(" "),_c('img',{staticClass:"foreground-image",attrs:{"src":_vm.imageSrc}})])
}
var staticRenderFns = []

export { render, staticRenderFns }